export const ACCEPTED_IMAGE_FILES = [
  'image/gif',
  'image/heic',
  'image/jpeg',
  'image/png',
  'image/webp',
].join(',');
